import { render } from "./JobStatsBasic.vue?vue&type=template&id=18fc585a&ts=true"
import script from "./JobStatsBasic.vue?vue&type=script&lang=ts"
export * from "./JobStatsBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__